import React from 'react';
import MainContext from '../../../../contexts/MainContext';
import PrematchContext from '../../../../contexts/PrematchContext';
import { SeoContext } from '../../../../data/seo/SeoContextProvider';
import { useAbsolutePath } from '../../../../data/seo/seoRouteUtils';
import { handleCanonicalUrl, isSeoSettingsNoFollow } from '../../../../data/seo/seoUtils';
import { classIf, getEncodedURI } from '../../../../data/utils';

function InEvidenzaCompetitionItem(props) {
    const mainContext = React.useContext(MainContext);
    const seoContext = React.useContext(SeoContext);
    const prematchContext = React.useContext(PrematchContext);

    function handleClick() {
        prematchContext.toggleTournament(props.uniqueId);
    }

    function handleClickHref(url,e){
        e.preventDefault();
    	if(!window.appConfig.SHOP_MODE){
            if(!selected)
    		    handleHistory(url);        	
        }
    }

    function handleHistory(url){
        if(window.history){
            seoContext.refreshPathname(competitionPath,mainContext.currentSection.current);
            handleCanonicalUrl(url);
            if(mainContext.historyNavigationEnabled){
                if(window.location.pathname != url) {
                    window.history.pushState(window.history.state, null, url);
                }
            }else{
                window.history.replaceState(window.history.state, null, url);
            }
        }
    }

    // function getParentsUrlPath(){
    //     return [{'path':props.sportUrlPath,'suffix':props.sportUrlPathSuffix}];
    // }

    const competitionPath = `${props.urlPath}${props.urlPathSuffix}`;
    const absoluteCompetitionPath = useAbsolutePath(competitionPath, null, props.urlPathSeo);
    const noFollow = isSeoSettingsNoFollow(props.urlPathSeoSettings);

    const selected = prematchContext.isTournamentSelected(props.uniqueId);
    const icoCategory = props.categoryIcon;
     const eventTimeFilter = prematchContext.currentFilter || 'ALL';
    return (
         <a href={getEncodedURI(absoluteCompetitionPath)} onClick={handleClickHref.bind(this,absoluteCompetitionPath)} {...(noFollow ? {rel: 'nofollow'}:{})} >
            <div className={"elemento-competizioni-widget singola-competizione bg-bianco pointer nero" + classIf(selected, 'competizione-attiva')} onClick={handleClick}>
                <div className="paese-widget-sx">
                    <div className={`img-fluid ico-cat ${icoCategory}`}></div>
                    <span>{props.descrizione}</span>
                </div>
                {props.isLive &&
                    <span className="live-badge"></span>
                }
                <span>{props.eventsCountByFilter?.[eventTimeFilter] ?? props.eventsCount}</span>
            </div>
        </a>
    );
}
    
export default InEvidenzaCompetitionItem;